import * as angular from 'angular';

import { ComponentDefinition, KeyValuePair, ContextualField, PropertyType } from '../../../models';
import { TextConfiguration } from '../text.configuration';
import * as Fields from '../../../common/helpers/contextual';

class TextContextualController implements angular.IComponentController {
    cancel: () => void;
    configuration: TextConfiguration;
    formController: angular.IFormController;
    options: KeyValuePair<number, string>[];
    properties: ContextualField[];
    save: () => void;

    private _originalConfiguration: TextConfiguration;

    static $inject = ['$q'];
    constructor(private _$q: angular.IQService) {
    }

    $onInit() {
        this.properties = [
            angular.copy(Fields.DateFormat),
            {
                modelName: 'theme',
                propertyType: PropertyType.Select,
                label: 'Theme',
                placeholder: 'Theme',
                propertyName: 'themeProperty',
                icon: 'fa-tint',
                extraData: {
                    options: [
                        { key: 0, value: 'Blue' },
                        { key: 1, value: 'Gray' }
                    ],
                    sortAlpha: true,
                    sortAscending: true
                }
            }, 
            {
                modelName: 'hasSanitization',
                propertyName: 'hasSanitizationProperty',
                propertyType: PropertyType.Boolean,
                placeholder: 'HTML sanitization',
                label: 'HTML sanitization',
                icon: 'fa-bath danger',
                inlineHelp: 'Deactivating HTML sanitization is dangerous and insecure! Use at your own risks!'
            }
        ];
    }

    onSave(): angular.IPromise<void> {
        return this._$q.when(this.save());
    }

    onCancel() {
        this.configuration = angular.copy(this._originalConfiguration);
        this.cancel();
    }
}

export const wtTextContextual: ComponentDefinition = {
    componentId: 'wtTextContextual',
    controller: TextContextualController,
    template: require('./textContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '=',
        configuration: '=',
        save: '&?',
        cancel: '&?'
    }
};
